import { render, staticRenderFns } from "./saveUserGroupModal.vue?vue&type=template&id=e6dfa494&scoped=true"
import script from "./saveUserGroupModal.vue?vue&type=script&lang=js"
export * from "./saveUserGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6dfa494",
  null
  
)

export default component.exports